import React from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (

    <>
      <div className='footer'><br />
        {/* <h1>If you Have Any Questions Call Us On +91 9140458191</h1> */}
        <div className='footer1'>

          <div className='foot'>
            <h1>About us</h1>
            <p style={{ textAlign: 'justify' }}>Mom's Express is a  specialty Obstetrician  /  Gynecologist maternity center in Lucknow led  by  the Team of Dr. Mansi Shukul & Dr. Garima Gupta. At Mom's Express, we endeavor to provide facilities of highest international standards and unsurpassed service to our patients."
            </p>
          </div>
          <div className='foot' style={{ textAlign: 'center' }}>
            <h1>Quick Links</h1><br />

            <div style={{ marginLeft: '-50px' }}>
              <Link to='/' className='link'>Home</Link><br /><br />
              <Link to='/clinic' className='link'>About</Link><br /><br />
              <Link to='/gallery' className='link'>Gallery</Link><br /><br />
              <Link to='/contact' className='link'>Contact</Link>
            </div>

          </div>

          <div className='foot'>
            <h1 style={{fontSize:'22px', marginLeft:'-45px'}}>Dr. Mansi Shukul</h1>

            <div style={{ marginLeft: '-20px' }}>

              <p style={{ color: '#FFEBCD' }}>Obstetrician, Gynecologist, & Infertility
                M.B.B.S , D.G.O. (A.M.U) D.N.B. (Apollo Hospital).</p>
              <p><b>Mon,Wed, Fri,</b>: <br/> Morning : 10:30 AM To 02:00 PM </p>
              <p> <b>Tues,Thurs, Sat,</b>: <br/> Evening 05:30 PM  TO 08:30 PM</p>
            </div>

          </div>
          <div className='foot'>
            <h1  style={{fontSize:'22px'}}>Dr. Garima Gupta</h1>
            <p style={{ color: '#FFEBCD' }}>Obstetrician, Gynecologist, & Infertility
              M,B.B.S , D.G.O. ,(Lady Hardinge , New Delhi).
            </p>
            <p><b>Mon,Wed, Fri,</b>: <br/>Evening  05:30 PM  TO 08:30 PM</p>
            <p> <b>Tues,Thurs, Sat,</b>:<br/>  Morning : 10:30 AM To 02:00 PM</p>
          </div>
          <div className='foot'>
            <h1>Contacts</h1>
            <div style={{ marginLeft: '30px' }}>
              <p>+91 9140458191</p>
              <p>+91 8838291513</p>
              <p><span>Address</span>:  1/1, Vineet Khand , Opposite Jaipuria School, Gomtinagar, Lucknow, Uttar Pradesh -226010</p>
              <p><span>Email</span>: indusmaternity@gmail.com</p>
            </div>
          </div>

        </div>

      </div>

      <div className='disclame'>
        <p>2024-25 ©  Mom's Express Birth & Beyond All Rights Reserved. Designed by Creative Digital World</p>
      </div>


    </>
  )
}

export default Footer